import { green, amber, deepOrange, red } from "@material-ui/core/colors"

/**
 * Modo de acceso al API.
 *
 * PROXY (por defecto en cualquier host que no sea local): las peticiones van a
 * /api/dashboard/* (mismo origen) y es la Azure Function la que inyecta la
 * api-key server-side. La key NUNCA llega al navegador.
 *
 * DIRECTO (solo localhost): se llama al backend directamente usando la key de
 * dev que está en public/config.js.
 *
 * Se puede forzar cualquiera de los dos definiendo window.MASTER_USE_PROXY
 * (true/false) en public/config.js.
 */
const detectProxyMode = () => {
    if (typeof window === 'undefined') return true
    if (typeof window.MASTER_USE_PROXY === 'boolean') return window.MASTER_USE_PROXY
    const host = window.location.hostname
    // Cierra por defecto: cualquier despliegue real usa el proxy.
    return !(host === 'localhost' || host === '127.0.0.1' || host === '[::1]')
}

const USE_PROXY = detectProxyMode()

const config = {
    USE_PROXY,
    BASE_URL: USE_PROXY ? '/api/dashboard' : `${window.MASTER_API_URL}/api`,
    API_KEY_NAME: 'x-api-key',
    // En modo proxy queda vacío a propósito: el secreto lo pone la Function.
    API_KEY_VALUE: USE_PROXY ? '' : window.MASTER_API_KEY,
    GOOGLE_API_KEY: window.MASTER_GOOGLE_API_KEY, 
    APP_SECRET: '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',
    APP_BLOB_URL: process.env.REACT_APP_BLOB_URL,
    QR_SIZE: window.MASTER_QR_SIZE_LARGE,
    QR_SIZE_LARGE: window.MASTER_QR_SIZE_LARGE,
    QR_SIZE_SMALL: window.MASTER_QR_SIZE_SMALL
}

// (Se eliminó el console.log(config): volcaba APP_SECRET y la api-key a la consola.)

const defaultAuthConfig = {
    token: "",
    refreshToken: "",
    context: {
        email: "",
        full_name: "",
        id_group: "",
        id_merchant: "",
        id_profile: "",
        identity: ""
    },
    nbf: 0,
    exp: 0,
    iat: 0,
    iss: "",
    aud: ""
}
const flexiaConstants = {
    sessionTimeoutBuffer: 60000, //in milliseconds
    timerIntervalColors: [[green[500], 0.33], [amber[500], 0.33], [deepOrange[500], 0.33], [red[500]]]
}

const modules = {
    users: { id: 1, name: 'Users' },
    profiles: { id: 2, name: 'Profiles' },
    groups: { id: 3, name: 'Groups' },
    locations: { id: 4, name: 'Locations' },
    programs: { id: 5, name: 'Programs' },
    cardholders: { id: 6, name: 'Cardholders' },
    promotions: { id: 7, name: 'Promotions' },
    reports: { id: 8, name: 'Reports' }
}

const parseJwt = (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}
const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result.replace(/^data:image\/[a-z]+;base64,/, ""))
    reader.onerror = error => reject(error)
})
const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}
export { config, defaultAuthConfig, flexiaConstants, modules, parseJwt, toBase64, addDays }